/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sidebar_Allfiles1Inputs */

const zh_sidebar_allfiles1 = /** @type {(inputs: Sidebar_Allfiles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全部`)
};

const en_sidebar_allfiles1 = /** @type {(inputs: Sidebar_Allfiles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All`)
};

const es_sidebar_allfiles1 = /** @type {(inputs: Sidebar_Allfiles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos`)
};

/**
* | output |
* | --- |
* | "All" |
*
* @param {Sidebar_Allfiles1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const sidebar_allfiles1 = /** @type {((inputs?: Sidebar_Allfiles1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sidebar_Allfiles1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_sidebar_allfiles1(inputs)
	if (locale === "en") return en_sidebar_allfiles1(inputs)
	return es_sidebar_allfiles1(inputs)
});
export { sidebar_allfiles1 as "sidebar_allFiles" }